export default "__VITE_ASSET__CWAc3URI__"